export default `
  query listEnterpriseCustomers($limit: Int, $nextToken: String) {
    listEnterpriseCustomers(limit: $limit, nextToken: $nextToken) {
      items {
        id
        company
        quantity
        createdAt
        startDate
        expirationDate
        payerUserEmail
        payerUser {
          id
          email
          firstname
          lastname
        }
      }
      nextToken
    }
  }
`
